import type { ContactFailure } from '@porotutu/http/contact'

export type FieldError = ContactFailure

export type Refinement<T> = (values: T) => FieldError[]

export function firstPerPath(failures: FieldError[]): FieldError[] {
  const seen = new Set<string>()

  return failures.filter((failure) => {
    if (seen.has(failure.path)) return false

    seen.add(failure.path)

    return true
  })
}

export function refusalsFrom<T>(values: T, refine: Refinement<T>[]): FieldError[] {
  return firstPerPath(refine.flatMap((refinement) => refinement(values)))
}
